import { Box, useDisclosure } from '@chakra-ui/react';

import { useEffect, useRef, useState } from 'react';
import { Condition } from 'Component/others';
import Drag from 'UiKit/drag';
import { isEmpty } from 'lodash';

import FaceTracking from 'View/monitoring/component/face-tracking';
import ViolationModal from 'View/monitoring/component/violation-modal';
import useFaceModel from 'Store/face-model';

import styles from './styles.module.css';

const Camera = ({ monitoringStatus }) => {
  const { faceModel } = useFaceModel();
  const NOW = Date.now();
  const GAP_THRESHOLD_VIOLATION = 5000;
  const timerRef = useRef(null);
  const lastFacePositionRef = useRef(null);
  const lastMovementTimeRef = useRef(NOW);
  const [isFaceRecognize, setIsFaceRecognize] = useState(false);

  const { isOpen: isOpenViolationModal, onOpen: onOpenViolationModal, onClose: onCloseViolationModal } = useDisclosure();

  const onTracking = (value) => setIsFaceRecognize(value);

  const onResetViolation = () => {
    const audioElement = document.getElementById('camera-violation__sound');
    audioElement?.pause();

    clearTimeout(timerRef.current);
    timerRef.current = null;
    onCloseViolationModal();
  };

  useEffect(() => {
    if (isFaceRecognize && !isOpenViolationModal) {
      if (timerRef.current) onResetViolation();
    } else if (!isEmpty(faceModel)) timerRef.current = setTimeout(() => onOpenViolationModal(), GAP_THRESHOLD_VIOLATION);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
    /* eslint-disable-next-line */
  }, [isFaceRecognize, isOpenViolationModal, faceModel]);

  return (
    <Drag elementId="floating-camera-stream" defaultPosition={{ left: 'calc(100vw - 208px)', bottom: '32px' }}>
      <Box className={styles['camera__container']}>
        {/* Box Face Tracking */}

        <Condition statement={!isOpenViolationModal}>
          <FaceTracking
            lastFacePositionRef={lastFacePositionRef}
            lastMovementTimeRef={lastMovementTimeRef}
            width="176px"
            height="99px"
            isOpen={true}
            className={styles['camera__video']}
            isMonitoring
            onTracking={onTracking}
          />
        </Condition>

        {/* Violation Modal */}

        <Condition statement={isOpenViolationModal}>
          <ViolationModal
            lastFacePositionRef={lastFacePositionRef}
            lastMovementTimeRef={lastMovementTimeRef}
            onResetViolation={onResetViolation}
            monitoringStatus={monitoringStatus}
          />
        </Condition>
      </Box>
    </Drag>
  );
};

export default Camera;
